//----- Attribute filters logic -----

// TODO: All of the price slider code should be pushed into its own module and dynamically loaded in as and when needed.

// ----- Global Variables -----
// Updates the correct content list as the old list will be removed after AJAX content update complete.
var contentContainer = ".contentContainer:not([data-content-updating=true])";
const filterForm = "#attribute-filters-form";

var filtersModalStatus = false;

//Sticky toggle. 
function stickyFilterToggle() {
  // Get context.
  let context = $('#filters-toggle');
  if (!context.attr(expressSelectors()['axis-sticky']['initialise'])) {
    AXISDebug.output(1,"Product List: Sticky filter toggle has " + expressSelectors()['axis-sticky']['initialise'] + " using that functionality instead of bespoke code path.");
    return false;
  }
  // If filters exist.
  if (context) {
    // Create sticky config.
    let config = {
      "top-anchor": "mainContentContainer:top",
      "btm-anchor": "mainContentContainer:bottom",
      "breakpoint": "small"
    }
    // Initialise.
    let init = AXISSticky.initialise(context, config);
  }
}
//Initialise the sticky toggle.
stickyFilterToggle();

function filterMobileToggle() {
  $(contentContainer + ' #attribute-filters-form').on("on.zf.toggler", () => {
    
    $('#attribute-filters-form').css('height', getWindowHeight);

    bodyScrollLock();

    setMobileFilterStatus();
    // Due how the filters are update after AJAX we need to remove the animate otherwise when updated via AJAX the animate will fire.
    
    $(contentContainer + ' #attribute-filters-form').removeClass('animate');
  });

  $(contentContainer + ' #attribute-filters-form').on("off.zf.toggler", () => {
    // bodyScrollLock();
    setMobileFilterStatus();
    // Added animate class back in so if the user were to re-open the modal appears like a drawer.
    $(contentContainer + ' #attribute-filters-form').addClass('animate');
    $('#attribute-filters-form').css('height', 0);
  });
}

if ($('#attribute-filters-form').length) {
  filterMobileToggle();
  // Reset flag, otherwise next list callback will open by defeault.
  setMobileFilterStatus();
}

// Set flag in local storage so if filters AJAX'd then the modal will automatically popup.
function setMobileFilterStatus() {
  if ($('#attribute-filters-form').hasClass('active')) {
    filtersModalStatus = true;
  } else {
    filtersModalStatus = false;
  }
}

// Retrieve from local storage filter modal active status.
function getMobileFilterStatus() {
  var status = filtersModalStatus;
  if (status == null) {
    status = false;
  }
  return status;
}

$('body').on('click', '#attribute-filters-form .close-button, [data-filter-close]', function () {
  // Removing the active class instead of using foundation toggler method as it just sets display:none using inline propertoes which om most cases conflict with the stylesheets animations.
  $('#attribute-filters-form').removeClass('active-updating active').css('height', 0);
  setMobileFilterStatus();
  // Re-enable body scroll bar.
  bodyScrollLock(true); 
});

$('body').on('slidechange', expressSelectors()['product-list']['filter-price-slider'], function (event, ui) {
  // Put form into context.
  getForm = $(this).parents('form');
  // Get min value.
  let min = $('#priceAttLow').data('attribute-id');
  // Increment value for vm.
  // Get max value.
  let max = $('#priceAttHigh').data('attribute-id');
  // Set filter type.
  let filterType = "AXISPriceSlider";
  // Get attribute id's.
  let rangeActionUpper = $(this).attr('data-action-upper');
  let rangeActionLower = $(this).attr('data-action-lower');
  // Get option prefix.
  let optionId = $('#price-slider').data('option-prefix');

  let attributeType = null;

  if (min == undefined || max == undefined) {
    AXISDebug.output(3,"Cannot submit price slider as either min or max is not set.");
    return false;
  }

  let attributeValue = rangeActionUpper + "=" + max + "&" + rangeActionLower + "=" + min;

  filterPost(filterType, attributeType, attributeValue, getForm);
});

function filterAttributeOverflow() {
  //Hide show more button when overflow list is active.
  $('.showMoreAttributes > a').on('click', function (event) {
    //Prevent the link from being followed.
    event.preventDefault();
    //Button context.
    let buttonId = $(this);
    let getSubmenuId = $(buttonId).parents('li:not(.is-submenu-item)').attr('id');
    // Get menu context.
    let submenu = buttonId.next('ul.submenu');
    let menuId = $("#filters").attr('data-accordion-menu');
    // Hide button.
    $(buttonId).addClass('hide');
    // As this is a foundation menu open submenu. ( this will only work with accordion menu's )
    //$('#filters').foundation('down', submenu);
    //Apply scroller.
    AXISResponsiveMenu.measureMenuItems('#' + getSubmenuId);
    $('[data-accordion-menu=' + menuId + ']').on('up.zf.accordionMenu', function() {
      buttonId.removeClass('hide');
      // Remove scoll container.
      $('#' + getSubmenuId).find('.menu-scroll-container').contents().unwrap();
      // Make sure the aria-expanded flag is unset.
      //$('#' + getSubmenuId).attr('aria-expanded', false);
      // Remove listener.
      $('[data-accordion-menu=' + menuId + ']').off('up.zf.accordionMenu');
    });
  });

  //Filter attribute show more / less 
  $('.showLessAttributes').on('click', function (event) {
    //Prevent the link from being followed.
    event.preventDefault();
    //Button context.
    var buttonId = $(this);
    //Get the parent Id used for toggling the submenu.
    var parentId = $(buttonId).parent('ul.submenu').attr('id');
    // Get submenu we're about to close.
    let submenu = buttonId.closest('ul.submenu');
    // Toggle foundation menu ( this will only work for accordion's ).
    $('#filters').foundation('up', submenu);
    //Toggle foundation menu.
    //$('#filters').foundation('toggle', $('#' + parentId));
    //Get parent link id so the hide class can be removed.
    var parentLink = $('#' + parentId).attr('aria-labelledby');
    $('#' + parentLink + '> a').removeClass('hide');

    var getSubmenuId = $(buttonId).parents('.scroller').attr('id');
    //Remove scroller.
    AXISResponsiveMenu.measureMenuItems('#' + getSubmenuId);
  });
}
filterAttributeOverflow();

if ($('#productList').length) {
  var storedFilters = AXISResponsiveMenu.getStoredActiveSubmenu("filters");
}


//--- AJAX Logic --- 
//--- Attribute filters functionality ---
//Checks which view to apply when updating the product list.
var listViewType;

function viewStatus() {
  if ($('.AXISViewGrid').hasClass('disabled')) {
    listViewType = $('.AXISViewGrid').attr('request-view');
  } else if ($('.AXISViewList').hasClass('disabled')) {
    listViewType = $('.AXISViewList').attr('request-view');
  }
}

//Filter global variables & functions.
var filterRequestSetup, filterType, attributeType, attributeValue, layoutOverrideStatus, layoutOverrideValue;

$('body').on('click', '#attributeFilterModalForm ul li', function (event) {
  event.stopPropagation();
  //Get filter id.
  var listItemId = $(this).attr('id');
  //Setting timeout to let the attribute list expand before moving the li which is active to the top of the view. 
  setTimeout(function () {
    //If filter id is defined then move the filter option to the top of the view.
    if (listItemId != undefined || listItemId != null) {
      var elmnt = document.getElementById(listItemId);
      //Scroll the active li to the top of the view and set the smooth property. ( IE doesn't support the smooth property ).
      elmnt.scrollIntoView({
        behavior: "smooth"
      });
    }
  }, 200);
});

// Price slider initialise process.
function priceSlider(context) {
  // Price filter context.
  let priceFilter;
  if (context) {
    // Then you just ajax'd.
    priceFilter = context.find(expressSelectors()['product-list']['filter-price-slider']);
  } else {
    priceFilter = $(expressSelectors()['product-list']['filter-price-slider']);
  }
  // if price filter exists.
  if (priceFilter.length > 0) {
    // Initialise.
    let priceSliderInitialise = AXISSliders.initialise(priceFilter);

    if (!priceSliderInitialise) {
      AXISDebug.output(2, "Failed to initialise price slider.");
    }
  }
}

priceSlider();

var mobileScrollPos = 0;

//Used to determine whether to lock the list/grid view state.
layoutOverrideStatus = false;
//TODO: legacy code from the somdiff project getForm shouldnt really be a global variable.
var getForm;

function filterPost(filterType, attributeType, attributeValue, context) {
  var filterData;
  // Check to see if sort form has been passed in.
  let sortForm = context.attr(expressSelectors()['forms']['additional-form']);
  // Find it.
  sortForm = $('form[name="'+ sortForm + '"]');
  if (sortForm.length > 1) {
    sortForm = sortForm.first();
  }
  //If the form brings back the attribute type when being submitted/serialized it will be merged into the attribute value else (if not null) piece together the attributeType and attributeValue.
  if (attributeType == null) {
    //Typically used for the sorting functionality.
    filterData = attributeValue + "&filterType=" + filterType;
  } else if (attributeType != null) {
    //Typically used for individual filters.
    filterData = attributeType + "=" + attributeValue + "&filterType=" + filterType;
  }
  if (!sortForm.length) {
    //layout override logic.
    if (layoutOverrideStatus == false) {
      //Checks whether its a grid or list layout.
      viewStatus();
      //Assigns view status data to variable.
      var listViewTypeData = "listViewType=" + listViewType
    } else if (layoutOverrideStatus == true) {
      //If the override status is true then get the requested view.
      var listViewTypeData = "listViewType=" + layoutOverrideValue
    }
    //If on keywords search results page AJAX the search terms along with the context (EBG or keywordsearch).
    filterData = filterData + "&" + getListContext();
  }

  mobileScrollPos = $('#attribute-filters-form').scrollTop();

  // Store the current active filters in an object.
  var storeActiveSubmenu = AXISResponsiveMenu.getActiveSubmenu("filters");

  // Store the scroll position.
  AXISResponsiveMenu.getListScrollPosition("filters", ["#appliedFilters"]);

  //Stores the applied sorting for submission. 
  var appliedSorting;
  // Default back to old functionality if sort form has not been provided in additional form attribute.
  if (!sortForm.length) {
    //Put the selected sort option into context.
    var sortSelector = $('.AXISSort').children("option:selected");
    //If the days sort selector exists then put it into context.
    var daysSelector = null;
    if ($('.sort-by-days-select').length) {
      daysSelector = $('.sort-by-days-select').children("option:selected");
    }
    //Prevents the sort by selector from being reset when a filter is applied.
    appliedSorting = getSortDirection(sortSelector) + "&" + getSortColumn(sortSelector) + ((daysSelector != null) ? "&" + getDaysScope(daysSelector) : '');
  } else {
    appliedSorting = AXISAjax.serialise(sortForm);
  }
  // console.log("Scroll position: " + menuScrollPosition);
  var AJAXPostURL = AXISAjax.postUrl(getForm, false, true);

  let responseContainer = context.attr(expressSelectors()['ajax']['response-context']);
  if (responseContainer) {
    responseContainer = $('#' + responseContainer);
  } 
  
  AXISDebug.output(1, "Posting to: " + AJAXPostURL);
  mobileScrollPos = $('#attribute-filters-form').scrollTop();
  //AJAX Post.
  //AXISAjax.post(AJAXPostURL, filterData + "&" + listViewTypeData + appliedSorting, "html", context, true).then((data) => {
  AXISAjax.post(AJAXPostURL, filterData + (listViewTypeData ? "&" + listViewTypeData : "") + (appliedSorting ? "&" + appliedSorting : ""), "html", context, true).then((data) => {
    // Get response.
    let response = data['data'];
    if (response) {
      // Fallback to old way.
      if (!responseContainer) {
        responseContainer = $('.contentContainer').parents('.callbackListContainer');
      }
      // Update DOM.
      responseContainer.html(response);
      // Scroll to top of response container.
      scrollIntoView(responseContainer);
    }
  });
}

if ($('#productListItems').length > 0) {
  let updateUrlElement = $('#updateUrl');
  if (updateUrlElement.length) {
    updateUrl.initialise(updateUrlElement);
  }
}

//Prevent the remove links from being followed.
$('body').on('click', "#appliedFilters  a", function (event) {
  event.preventDefault();
});

//Standard catagory filter.
$('body').on('change', '.attributeList .control > input', function () {
  getForm = $(this).parents('form');
  //Filter type.`
  filterType = "AXISCatagory";
  //Type of action that needs to be carried out (add or remove).
  attributeType = $(this).attr('name');
  //The filter that will be either added or removed.
  attributeValue = $(this).val();
  //Send variables to filter posting function.
  filterPost(filterType, attributeType, attributeValue, getForm);
});

// Make the attribute scroll into view.
$('body').on('click', '.attributeList .is-accordion-submenu-parent > a', function(event) {
  event.stopPropagation();
  // Capture context.
  let context = $(this);
  // Store Id.
  let id = context.closest('li').attr('id');
  // Check if Id is defined.
  if ((id == undefined) || (id == "")) {
    AXISDebug.output(2,"Could not scroll attribute into view due to no Id being defined.");
    return false;
  }
  if (currentBreakpoint() <= 2) {
    // Set timeout to make sure opening animations have run.
    setTimeout(() => {
      let element = document.getElementById(id);
        //Scroll the active li to the top of the view and set the smooth property. ( IE doesn't support the smooth property ).
        element.scrollIntoView({
          behavior: "smooth"
        });
    }, 200);
  }
});

//Removing a filter
$('body').on('click', ".remove-attribute, .clear-all-attributes", function () {
  //Puts the form into context which will be used to construct the submission url.
  getForm = $(this).parents('form');
  //Type of action that needs to be carried out (add or remove).
  attributeType = $(this).data('ajax-action');
  //The filter that will be either added or removed.
  attributeValue = $(this).data('attribute-id');
  //Send variables to filter posting function.
  filterPost(filterType, attributeType, attributeValue, getForm);
});


//General sorting functions used for constructing the post URL.
//Get the product list context & if it's a search page get the search terms.
//The updatingUrl parameter gets set to true when the Ajax post has been completed.
function getListContext(updatingUrl) {
  let searchTerms, value = "";
  // Element that holds context data.
  let element = $('.callbackListContainer');
  // Get list context.
  let context = element.data('context-name');
  // Get Context Variable.
  let contextVariable = element.data('context-variable');
  // Get Context Value.
  let contextValue = element.data('context-value');

  if (context) {
    value = "context=" + context;
  }

  if (contextVariable && contextValue) {
    if (value == "") {
      value = contextVariable + "=" + contextValue;
    } else {
      value = value + "&" + contextVariable + "=" + contextValue;
    }
    if (AXISDebug.level() >= 3) {
      AXISDebug.output(1,"Listing: Context variable exists: " + value);
    }
  } else if (context == "search") {
    if (value == "") {
      value = contextVariable + "=" + getUrlParameter('keyword');
    } else {
      value = value + "&" + contextVariable + "=" + getUrlParameter('keyword');
    }
    if (AXISDebug.level() >= 3) {
      AXISDebug.output(1, "Listing: This is a search page get keywords: " + value);
    }
  }

  if (value != "") {
    if (AXISDebug.level() >= 3) {
      AXISDebug.output(1,"Listing: The context: " + context);
    }
    return value;
  } else {
    return false;
  }
}

//Sort direction.
function getSortDirection(sortSelector) {
  // Get value.
  let value = sortSelector.attr('data-direction');
  if (value) {
    //Get the selected sort direction.
    var sortDir = "sort_dir=" + value;
    AXISDebug.output(1, "Sort Direction value: " + sortDir);
    return sortDir;
  } else {
    return false;
  }
  
}
//Sort column.
function getSortColumn(sortSelector) {
  // Get value.
  let value = sortSelector.val();
  if (value) {
    //Get the selected sort column.
    var sortColumn = "sort_column=" + sortSelector.val();
    AXISDebug.output(1, "Sort Column value: " + sortColumn);
    return sortColumn;
  } else {
    return false;
  }
  
}

//Days scope ( typically used for recently added products )
function getDaysScope(daysSelector) {
  // Get value.
  let value = daysSelector.val();
  if (value) {
    // Get operation id.
    let operationId = $('.sort-by-days-select').attr('ajax-operation');
    // If select is not in context then find it.
    if (operationId == undefined) {
      operationId = $('.sort-by-days-select').attr('name');
      // If its still undefined then hardcode it.
      if (operationId == undefined) {
        operationId = "days"
      }
        
    }
    return operationId + "=" + value;
  } else { 
    return false;
  }
}

// New-ish function based on the original updateList() function, this is not 100% generic but at the time of writing this function ( 840199 ) was trying to move towards using the generic AXISAjax.callback / form submission to handle the response for the sorting options which would allow us to add new sorting options without needing to modify the JS.
function initialiseList(context) {
  if (AXISDebug.level() >= 3) {
    AXISDebug.output(1,"Listing: Attempting to initialise list.", context);
  }
  let contentContainer = context.find('.contentContainer');
  // Fallback.
  if (!contentContainer.length) {
    contentContainer = context.closest('.contentContainer');
    if (!contentContainer.length) {
     AXISDebug.output(3,"Listing: Could not find content container", context);
      return false;
    }
  }
  // Find filters form.
  let filtersForm = contentContainer.find('#attribute-filters-form');
  if (filtersForm.length) {
    if (AXISDebug.level() >= 3) {
      AXISDebug.output(1,"Listing: Filters found", filtersForm)
    }
    filterAttributeOverflow();
    var elem = new Foundation.Toggler(filtersForm, {});
    let mobileFilterStatus = getMobileFilterStatus();
    if (AXISDebug.level() >= 3) {
      AXISDebug.output(1, "Listing: Filters Mobile popup status: " + getMobileFilterStatus());
    }
    if (getMobileFilterStatus()) {
      filtersForm.css('height', getWindowHeight()).addClass('active-updating');
    }
    // Initialise mobile filter toggle event listeners.
    filterMobileToggle();
    // Restore sticky filter toggle functionality.
    stickyFilterToggle();
    // Initialise price slider.
    priceSlider(contentContainer);

    let lastPositionRestored = AXISResponsiveMenu.setActiveSubmenu("filters");

    if (lastPositionRestored) {
      if (filtersForm.attr('data-restore-last-position')) {
        let appliedFilters = $('#appliedFilters');
        let filtersHeading = $('.filters-header').height();
        let restoreScrollPosition = AXISResponsiveMenu.setListScrollPosition("filters");
        // If applied filters exists.
        if (appliedFilters.length > 0) {
          let appliedFiltersHeight = appliedFilters.height();
          restoreScrollPosition = (restoreScrollPosition + appliedFiltersHeight);
        }
        restoreScrollPosition = (restoreScrollPosition + filtersHeading);
        if (currentBreakpoint() <= 2) {
          $('#attribute-filters-form').scrollTop(parseInt(restoreScrollPosition));  
          setTimeout(() => {
            // Re-enabled scroller.
            $('#attribute-filters-form').trigger('touchstart');
          }, 1000);       
        } else {
          //$(document).scrollTop(restoreScrollPosition);
        }
      } else {
        if (currentBreakpoint() <= 2) {
          $('#attribute-filters-form').scrollTop(0);
        } else {
          if ($('#updateUrl').length) {
            let listTop = $('#updateUrl').offset().top;
            //console.log("test",555);
            $(window).scrollTop((listTop - 200)); 
          }
        }
      }
    }

    // Update url element.
    const updateUrlElement = $('#updateUrl');

    if (updateUrlElement.length) {
      updateUrl.set(updateUrlElement);
    }
    if (AXISDebug.level() >= 3) {
      AXISDebug.output(1, "Update list: Here is the update url obj", updateUrlElement);
    }
    if (getMobileFilterStatus()) {
      // Removing the listener as a temp fix, this needs to be re-written to use modals esspecially after the wearesync project, adding timeout to allow for all the DOM manipulation to take place.
      setTimeout(() => {
        $('#attribute-filters-form').removeClass('active-updating').addClass('active');
      }, 10)
    }
  }  
}


var component = $.component = {
  initialiseList: (context) => {
    return initialiseList(context);
  }
}

export { component }






